export default "__VITE_ASSET__c23f968b__"